import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const LegalAgreementCheckboxSet = (props) => {

    const { promotionSettings, register, formState } = props;
    const legal = promotionSettings.terms_conditions.text;
    const [sanitizedLegals, setSanitizedLegals] = useState([]);
    const { t, i18n } = useTranslation();

    const config = {
        ADD_ATTR: ['target']
    };

    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName.toLowerCase() === 'a') {
            node.setAttribute('target', '_blank');
        }
    });

    useEffect(() => {
        const sanitized = legal.map(item => ({
            ...item,
            label: DOMPurify.sanitize(item.label, config),
        }));
        setSanitizedLegals(sanitized);
    }, [legal]);

    return (
        <div className="promo-fields-group">
            {sanitizedLegals.map((checkbox, i) => (
                <div className="promo-fields" key={`${checkbox.name}-${i}`}>
                    <div className="promo-field">
                        <div className="checkbox">
                            <input type="checkbox" name={checkbox.name} id={checkbox.name} {...register(checkbox.name, { required: checkbox.required })} />
                            <label htmlFor={checkbox.name} className="form-check-label" dangerouslySetInnerHTML={{ __html: sanitizedLegals[i].label }} />
                        </div>
                        {(formState.errors[`${checkbox.name}`]?.type === "required") && (
                            <span className="error error--checkbox">{checkbox.required_message}</span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LegalAgreementCheckboxSet;